import axios from 'axios'
import store from '@/store/store'

export default () => {
	return axios.create({
		baseURL: 'https://db.rmpdashboard.com',
		//baseURL: 'http://localhost:8081',
		headers: {
			Authorization: `Bearer ${store.state.token}`
		}
	})
}
	/*baseURL: 'https://api.rmpdashboard.com/',
		//baseURL: 'https://db.rmpdashboard.com/', */


// WEBPACK FOOTER //
// ./src/services/Api.js